jQuery(document).ready(function ($) {
  // Off-canvas open
  $(document).on('opened.zf.offCanvas', function () {
    console.log('Mobile menu opened');
    $('a[data-header-order-link]').addClass('hide');
  });

  // Off-canvas close
  $(document).on('closed.zf.offCanvas', function () {
    console.log('Mobile menu closed');
    $('a[data-header-order-link]').removeClass('hide');

  });

  // //menu dropdown 
  function manageAccountDropdown() {
    // Remove existing event listeners to prevent duplicates
    $('.account-dropdown-trigger').off('mouseenter mouseleave');
    $('.dropdown-pane').off('mouseenter mouseleave');

    if (window.innerWidth > 1025) {
      $('.account-dropdown-trigger').each(function () {
        const $trigger = $(this);
        const $dropdown = $trigger.siblings('.dropdown-pane');

        // Hover on trigger
        $trigger.on('mouseenter', function () {
          $dropdown.addClass('is-open');
        });

        $trigger.on('mouseleave', function () {
          setTimeout(function () {
            // Only close if user is NOT inside dropdown
            if (!$dropdown.is(':hover')) {
              $dropdown.removeClass('is-open');
            }
          }, 150);
        });

        // Hover on dropdown
        $dropdown.on('mouseenter', function () {
          $dropdown.addClass('is-open');
        });

        $dropdown.on('mouseleave', function () {
          $dropdown.removeClass('is-open');
        });
      });
    }
  }

  // Initial call on page load
  manageAccountDropdown();

  // Add the resize listener
  $(window).on('resize', function () {
    manageAccountDropdown();
  });



});
